import { connect } from 'react-redux'
import { AuthState } from '../../common/auth/authReducer'
import { Statistics } from './Statistics'
import { getSpecificCompanyStatistics } from './store/StatisticsActions'
import { StatisticsState } from './store/StatisticsReducer'

const mapStateToProps = ({
  auth: { userCompanies },
  statistics: { companyStatistics },
}: {
  auth: AuthState
  statistics: StatisticsState
}) => ({
  companyStatistics,
  userCompanies,
})

const mapDispatchToProps = {
  getSpecificCompanyStatistics,
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics)
